const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Imagens enviadas pelo painel são salvas como "/api/files/..."; links externos ficam como estão.
export const resolveImg = (src) => (src && src.startsWith("/api/") ? `${BACKEND}${src}` : src);
